import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import type { ScheduleBoardWorkOrdersViewModel } from 'ab-socketModels/viewModels/scheduleBoard/scheduleBoardWorkOrder.viewModel';

import { WorkOrderStatus } from '@acceligentllc/shared/enums/workOrderStatus';

import { SET_PER_DIEM_FOR_WORK_ORDERS } from 'af-constants/reduxForms';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import type { SelectedWorkOrderModel } from 'af-models/scheduleBoard/scheduleBoard.models';

interface OwnProps {
	modalVisible: boolean;
	closeModal: () => void;
	onSave: () => void;
	selectedWorkOrders: SelectedWorkOrderModel[];
	workOrders: ScheduleBoardWorkOrdersViewModel;
}

type Props = OwnProps;

export default class AddPerDiemModal extends React.PureComponent<Props> {

	render() {
		const { modalVisible, selectedWorkOrders, onSave, closeModal, workOrders } = this.props;

		const unlockedWorkOrders = selectedWorkOrders.filter((_wo) => workOrders[_wo.code]?.status !== WorkOrderStatus.LOCKED);

		return (
			<CustomModal
				className="per-diem-modal"
				closeModal={closeModal}
				modalStyle="info"
				showModal={modalVisible}
				size="md"
			>
				<CustomModal.Header
					closeModal={closeModal}
					title="Add Per Diem to Work Orders"
				/>
				<CustomModal.Body>
					<Row>
						<Col sm={24}>
							Laborers on the following work order(s) will be marked for "Per Diem":
							<br />
							<div className="work-order-modal__codes-list">
								<div className="work-order-modal__codes-group">
									{unlockedWorkOrders.map((_workOrder) =>
										<span key={_workOrder.code}>
											<span className="icon-dot text-green" />
											{_workOrder.code}
										</span>
									)}
								</div>
							</div>
						</Col>
					</Row>
					<Row>
						<Col sm={24}>
							Per Diems are visible only to certain user roles and are indicated by a little green dot
							in the lower-right part of each laborer card.
							<div className="per-diem-modal__example">
								<div className="per-diem-modal__employee">
									J Doe
									<div className="per-diem-modal__indicator" />
								</div>
							</div>
						</Col>
					</Row>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Cancel"
						onClick={closeModal}
						style="secondary"
					/>
					<SubmitButton
						label="Add Per Diem"
						onClick={onSave}
						submitKey={SET_PER_DIEM_FOR_WORK_ORDERS}
						variant="primary"
					/>
				</CustomModal.Footer>
			</CustomModal>
		);
	}
}
